export const TASK_ROWS = [1, 2, 3, 4, 5, 6] as const;

export const OTHER_MATTERS = [
  { key: "dpWill", label: "Will" },
  { key: "dpFpoa", label: "Future power of attorney" },
  { key: "dpTax", label: "Tax" },
  { key: "dpBankterms", label: "Bank terms" },
] as const;

export type OtherMattersKey = (typeof OTHER_MATTERS)[number]["key"];

export const TASK_STATUS_OPTIONS = [
  { label: "Open", value: "open" },
  { label: "In progress", value: "in_progress" },
  { label: "Done", value: "done" },
] as const;
